const Section8 = () => {
  return (
    <div>
      <section
        className='bg-cover bg-center w-full 
  h-full
  space-y-4 py-12 sm:py-16 px-4 sm:px-8 md:px-20 sm:bg-white'
        style={{ backgroundImage: `url('Background3.png')` }}
      >
        <div className='flex flex-col items-center justify-center space-y-8 mt-8 sm:mt-12'>
          {/* First Part */}
          <div className='flex items-center space-x-6 sm:space-x-9 justify-center'>
            <img
              src='./sphere.png'
              alt='About Us'
              className='h-[14px] w-[20px] sm:h-[17px] sm:w-[23px]'
            />
            <h2 className='text-sm sm:text-base font-medium font-raleway text-black'>
              EnRich Family
            </h2>
            <img
              src='./sphere.png'
              alt='About Us'
              className='h-[14px] w-[20px] sm:h-[17px] sm:w-[23px]'
            />
          </div>

          <h3 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-Anton text-black leading-tight text-center px-2'>
            Meet Our Partners
          </h3>
        </div>
        {/* Grid of Images */}
        <div className='flex flex-col gap-4 mt-[6px] py-12 sm:grid sm:grid-cols-5 sm:gap-4'>
          {/* item 1*/}
          <div className='flex flex-col items-center '>
            {/* Image */}
            <div className='flex items-center justify-center'>
              <img
                src='./Care-logo.png'
                alt='About Us'
                className='h-[80px] w-[80px] sm:h-[120px] sm:w-[120px] md:h-[180px] md:w-[180px] lg:h-[120px] lg:w-[120px] object-contain'
              />
            </div>
          </div>
          {/* item 2 */}
          <div className='flex flex-col items-center'>
            {/* Image */}
            <div className='flex items-center justify-center'>
              <img
                src='./state.png'
                alt='About Us'
                className='h-[80px] w-[80px] sm:h-[120px] sm:w-[120px] md:h-[180px] md:w-[180px] lg:h-[120px] lg:w-[120px] object-contain'
              />
            </div>
          </div>
          {/* Item 3 */}
          <div className='flex flex-col items-center '>
            {/* Image */}
            <div className='flex items-center justify-center'>
              <img
                src='./Katsina.png'
                alt='About Us'
                className='h-[80px] w-[80px] sm:h-[120px] sm:w-[120px] md:h-[180px] md:w-[180px] lg:h-[120px] lg:w-[120px] object-contain'
              />
            </div>
          </div>
          {/* item 4*/}
          <div className='flex flex-col items-center justify-center h-full'>
            <div className='flex items-center justify-center'>
              <img
                src='./Life.png'
                alt='About Us'
                className='h-auto w-[140px] sm:w-[160px] md:w-[180px] lg:w-[160px] object-contain'
              />
            </div>
          </div>
          {/* item 5 */}
          <div className='flex flex-col items-center '>
            <div className='flex items-center justify-center'>
              <img
                src='./Kadict.png'
                alt='About Us'
                className='h-[80px] w-[80px] sm:h-[120px] sm:w-[120px] md:h-[180px] md:w-[180px] lg:h-[120px] lg:w-[120px] object-contain'
              />
            </div>
          </div>
        </div>


      </section>

      <section className='bg-white space-y-8 py-12 px-6 md:px-20'>
        {/* Up part Section */}
        <div className='flex flex-col relative md:flex-row items-start justify-between md:items-center mb-12'>
          <div className='text-center lg:text-left space-y-3  '>
            <div className='flex items-center space-x-2 text-left mb-1'>
              <img
                src='./sphere.png'
                alt='About Us'
                className='h-[17px] w-[23px]'
              />
              <p className='text-sm text-orange-400 font-raleway '>
                Blog Posts
              </p>
            </div>
            <div>
              <h2 className='text-4xl font-Anton text-orange-900'>
                Most Popular Posts
              </h2>
            </div>
          </div>
          <div className='flex items-center mt-4'>
            <button className='bg-orange-500 hover:bg-orange-600 font-raleway text-white text-sm px-7 py-3 rounded-md flex items-center space-x-2'>
              All Blog Post
              <svg
                width='20'
                height='21'
                viewBox='0 0 20 21'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6.99961 1.19995L5.59961 2.69995L12.9996 10.2L5.59961 17.7L6.99961 19.2L15.9996 10.2L6.99961 1.19995Z'
                  fill='#FDF1E9'
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Grid of Cards */}
        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          
          {/*Card 1 */}
          <div className='bg-gray-200 shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition lg:w-[424px] lg:h-[463px] sm:w-[200px] sm:h-[242px] mt-11 ml-13'>
            <div className='relative px-8 py-2 '>
              <img
                src='./Card 2.png'
                alt='Thumb 1'
                className='w-[364px] h-[207.44px] sm:w-[100px] sm:h-[100px] object-cover'
              />
            </div>

            <div className='p-3 space-y-6'>
              <div className='flex space-x-2'>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  {/* ...SVG... */}
                  <span>21 April 2023</span>
                </div>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  {/* ...SVG... */}
                  <span>Comment(06)</span>
                </div>
              </div>

              <h3 className='text-lg font-semibold px-5 py-3 font-raleway text-orange-900'>
                The Benefits of hand washing in <br /> controlling Food-borne
                diseases
              </h3>

              <button className='mt-8 bg-orange-500 text-white text-sm px-5 py-2 rounded-md font-raleway flex items-center text-center justify-center w-[180px] h-[44px] hover:bg-orange-600 ml-8'>
                Read More
                {/* ...SVG... */}
              </button>
            </div>
          </div>

          {/* Card 2 */}
          <div className='bg-gray-200 shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition w-[424px] h-[463px] mt-11 ml-13'>
            <div className='relative px-8 py-2 '>
              <img
                src='./Card 1.png'
                alt='Thumb 1'
                className='w-[364px] h-[207.44px] object-cover'
              />
            </div>

            <div className='p-3 space-y-6'>
              <div className='flex space-x-2'>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  <svg
                    width='14'
                    height='16'
                    viewBox='0 0 14 16'
                    fill='none'
                    className='text-red-500'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M0 14.5186V6.5498H13.125V14.5186C13.125 14.9092 12.9883 15.2412 12.7148 15.5146C12.4414 15.7881 12.1094 15.9248 11.7188 15.9248H1.40625C1.01562 15.9248 0.683594 15.7881 0.410156 15.5146C0.136719 15.2412 0 14.9092 0 14.5186ZM9.375 8.77637V9.94824C9.375 10.1826 9.49219 10.2998 9.72656 10.2998H10.8984C11.1328 10.2998 11.25 10.1826 11.25 9.94824V8.77637C11.25 8.54199 11.1328 8.4248 10.8984 8.4248H9.72656C9.49219 8.4248 9.375 8.54199 9.375 8.77637ZM9.375 12.5264V13.6982C9.375 13.9326 9.49219 14.0498 9.72656 14.0498H10.8984C11.1328 14.0498 11.25 13.9326 11.25 13.6982V12.5264C11.25 12.292 11.1328 12.1748 10.8984 12.1748H9.72656C9.49219 12.1748 9.375 12.292 9.375 12.5264ZM5.625 8.77637V9.94824C5.625 10.1826 5.74219 10.2998 5.97656 10.2998H7.14844C7.38281 10.2998 7.5 10.1826 7.5 9.94824V8.77637C7.5 8.54199 7.38281 8.4248 7.14844 8.4248H5.97656C5.74219 8.4248 5.625 8.54199 5.625 8.77637ZM5.625 12.5264V13.6982C5.625 13.9326 5.74219 14.0498 5.97656 14.0498H7.14844C7.38281 14.0498 7.5 13.9326 7.5 13.6982V12.5264C7.5 12.292 7.38281 12.1748 7.14844 12.1748H5.97656C5.74219 12.1748 5.625 12.292 5.625 12.5264ZM1.875 8.77637V9.94824C1.875 10.1826 1.99219 10.2998 2.22656 10.2998H3.39844C3.63281 10.2998 3.75 10.1826 3.75 9.94824V8.77637C3.75 8.54199 3.63281 8.4248 3.39844 8.4248H2.22656C1.99219 8.4248 1.875 8.54199 1.875 8.77637ZM1.875 12.5264V13.6982C1.875 13.9326 1.99219 14.0498 2.22656 14.0498H3.39844C3.63281 14.0498 3.75 13.9326 3.75 13.6982V12.5264C3.75 12.292 3.63281 12.1748 3.39844 12.1748H2.22656C1.99219 12.1748 1.875 12.292 1.875 12.5264ZM11.7188 2.7998C12.1094 2.7998 12.4414 2.93652 12.7148 3.20996C12.9883 3.4834 13.125 3.81543 13.125 4.20605V5.6123H0V4.20605C0 3.81543 0.136719 3.4834 0.410156 3.20996C0.683594 2.93652 1.01562 2.7998 1.40625 2.7998H2.8125V1.39355C2.8125 1.25684 2.85156 1.14941 2.92969 1.07129C3.02734 0.973633 3.14453 0.924805 3.28125 0.924805H4.21875C4.35547 0.924805 4.46289 0.973633 4.54102 1.07129C4.63867 1.14941 4.6875 1.25684 4.6875 1.39355V2.7998H8.4375V1.39355C8.4375 1.25684 8.47656 1.14941 8.55469 1.07129C8.65234 0.973633 8.76953 0.924805 8.90625 0.924805H9.84375C9.98047 0.924805 10.0879 0.973633 10.166 1.07129C10.2637 1.14941 10.3125 1.25684 10.3125 1.39355V2.7998H11.7188Z'
                      fill='#FC6441'
                    />
                  </svg>

                  <span>15 April 2024</span>
                </div>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  <svg
                    width='18'
                    height='16'
                    viewBox='0 0 18 16'
                    fill='none'
                    className='text-red-600'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M12.3574 7.4873C12.3574 7.99512 12.1719 8.43457 11.8008 8.80566C11.4297 9.17676 10.9902 9.3623 10.4824 9.3623H4.91602L2.51367 11.1787C2.41602 11.2568 2.30859 11.2666 2.19141 11.208C2.09375 11.1494 2.04492 11.0615 2.04492 10.9443V9.3623C1.53711 9.3623 1.09766 9.17676 0.726562 8.80566C0.355469 8.43457 0.169922 7.99512 0.169922 7.4873V2.7998C0.169922 2.29199 0.355469 1.85254 0.726562 1.48145C1.09766 1.11035 1.53711 0.924805 2.04492 0.924805H10.4824C10.9902 0.924805 11.4297 1.11035 11.8008 1.48145C12.1719 1.85254 12.3574 2.29199 12.3574 2.7998V7.4873ZM15.1699 5.6123C15.6777 5.6123 16.1172 5.79785 16.4883 6.16895C16.8594 6.54004 17.0449 6.97949 17.0449 7.4873V12.1748C17.0449 12.6826 16.8594 13.1221 16.4883 13.4932C16.1172 13.8643 15.6777 14.0498 15.1699 14.0498H14.2324V15.6318C14.2324 15.749 14.1738 15.8369 14.0566 15.8955C13.959 15.9541 13.8613 15.9443 13.7637 15.8662L11.3613 14.0498H7.66992C7.16211 14.0498 6.72266 13.8643 6.35156 13.4932C5.98047 13.1221 5.79492 12.6826 5.79492 12.1748V10.2998H10.4824C11.2637 10.2998 11.9277 10.0264 12.4746 9.47949C13.0215 8.93262 13.2949 8.26855 13.2949 7.4873V5.6123H15.1699Z'
                      fill='#FC6441'
                    />
                  </svg>

                  <span>Comment(06)</span>
                </div>
              </div>

              <h3 className='text-lg font-semibold px-5 py-3 font-raleway text-orange-900'>
                The Benefits of hand washing in <br /> controlling Food-borne
                diseases
              </h3>

              <button className='mt-8 bg-orange-500 text-white text-sm px-5 py-2 rounded-md font-raleway flex items-center text-center justify-center w-[180px] h-[44px] hover:bg-orange-600 ml-8'>
                Read More
                <svg
                  width='20'
                  height='21'
                  viewBox='0 0 20 21'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M6.99961 1.19995L5.59961 2.69995L12.9996 10.2L5.59961 17.7L6.99961 19.2L15.9996 10.2L6.99961 1.19995Z'
                    fill='#FDF1E9'
                  />
                </svg>
              </button>
            </div>
          </div>
          {/* Card 3 */}
          <div className='bg-gray-200 shadow-lg rounded-lg overflow-hidden hover:shadow-lg transition w-[424px] h-[463px] mt-11 ml-13'>
            <div className='relative px-8 py-2 '>
              <img
                src='./Card 3.png'
                alt='Thumb 1'
                className='w-[364px] h-[207.44px] object-cover'
              />
            </div>

            <div className='p-3 space-y-6'>
              <div className='flex space-x-2'>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  <svg
                    width='14'
                    height='16'
                    viewBox='0 0 14 16'
                    fill='none'
                    className='text-red-500'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M0 14.5186V6.5498H13.125V14.5186C13.125 14.9092 12.9883 15.2412 12.7148 15.5146C12.4414 15.7881 12.1094 15.9248 11.7188 15.9248H1.40625C1.01562 15.9248 0.683594 15.7881 0.410156 15.5146C0.136719 15.2412 0 14.9092 0 14.5186ZM9.375 8.77637V9.94824C9.375 10.1826 9.49219 10.2998 9.72656 10.2998H10.8984C11.1328 10.2998 11.25 10.1826 11.25 9.94824V8.77637C11.25 8.54199 11.1328 8.4248 10.8984 8.4248H9.72656C9.49219 8.4248 9.375 8.54199 9.375 8.77637ZM9.375 12.5264V13.6982C9.375 13.9326 9.49219 14.0498 9.72656 14.0498H10.8984C11.1328 14.0498 11.25 13.9326 11.25 13.6982V12.5264C11.25 12.292 11.1328 12.1748 10.8984 12.1748H9.72656C9.49219 12.1748 9.375 12.292 9.375 12.5264ZM5.625 8.77637V9.94824C5.625 10.1826 5.74219 10.2998 5.97656 10.2998H7.14844C7.38281 10.2998 7.5 10.1826 7.5 9.94824V8.77637C7.5 8.54199 7.38281 8.4248 7.14844 8.4248H5.97656C5.74219 8.4248 5.625 8.54199 5.625 8.77637ZM5.625 12.5264V13.6982C5.625 13.9326 5.74219 14.0498 5.97656 14.0498H7.14844C7.38281 14.0498 7.5 13.9326 7.5 13.6982V12.5264C7.5 12.292 7.38281 12.1748 7.14844 12.1748H5.97656C5.74219 12.1748 5.625 12.292 5.625 12.5264ZM1.875 8.77637V9.94824C1.875 10.1826 1.99219 10.2998 2.22656 10.2998H3.39844C3.63281 10.2998 3.75 10.1826 3.75 9.94824V8.77637C3.75 8.54199 3.63281 8.4248 3.39844 8.4248H2.22656C1.99219 8.4248 1.875 8.54199 1.875 8.77637ZM1.875 12.5264V13.6982C1.875 13.9326 1.99219 14.0498 2.22656 14.0498H3.39844C3.63281 14.0498 3.75 13.9326 3.75 13.6982V12.5264C3.75 12.292 3.63281 12.1748 3.39844 12.1748H2.22656C1.99219 12.1748 1.875 12.292 1.875 12.5264ZM11.7188 2.7998C12.1094 2.7998 12.4414 2.93652 12.7148 3.20996C12.9883 3.4834 13.125 3.81543 13.125 4.20605V5.6123H0V4.20605C0 3.81543 0.136719 3.4834 0.410156 3.20996C0.683594 2.93652 1.01562 2.7998 1.40625 2.7998H2.8125V1.39355C2.8125 1.25684 2.85156 1.14941 2.92969 1.07129C3.02734 0.973633 3.14453 0.924805 3.28125 0.924805H4.21875C4.35547 0.924805 4.46289 0.973633 4.54102 1.07129C4.63867 1.14941 4.6875 1.25684 4.6875 1.39355V2.7998H8.4375V1.39355C8.4375 1.25684 8.47656 1.14941 8.55469 1.07129C8.65234 0.973633 8.76953 0.924805 8.90625 0.924805H9.84375C9.98047 0.924805 10.0879 0.973633 10.166 1.07129C10.2637 1.14941 10.3125 1.25684 10.3125 1.39355V2.7998H11.7188Z'
                      fill='#FC6441'
                    />
                  </svg>

                  <span>15 April 2024</span>
                </div>
                <div className='flex items-center px-5 space-x-2 font-raleway text-sm'>
                  <svg
                    width='18'
                    height='16'
                    viewBox='0 0 18 16'
                    fill='none'
                    className='text-red-600'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M12.3574 7.4873C12.3574 7.99512 12.1719 8.43457 11.8008 8.80566C11.4297 9.17676 10.9902 9.3623 10.4824 9.3623H4.91602L2.51367 11.1787C2.41602 11.2568 2.30859 11.2666 2.19141 11.208C2.09375 11.1494 2.04492 11.0615 2.04492 10.9443V9.3623C1.53711 9.3623 1.09766 9.17676 0.726562 8.80566C0.355469 8.43457 0.169922 7.99512 0.169922 7.4873V2.7998C0.169922 2.29199 0.355469 1.85254 0.726562 1.48145C1.09766 1.11035 1.53711 0.924805 2.04492 0.924805H10.4824C10.9902 0.924805 11.4297 1.11035 11.8008 1.48145C12.1719 1.85254 12.3574 2.29199 12.3574 2.7998V7.4873ZM15.1699 5.6123C15.6777 5.6123 16.1172 5.79785 16.4883 6.16895C16.8594 6.54004 17.0449 6.97949 17.0449 7.4873V12.1748C17.0449 12.6826 16.8594 13.1221 16.4883 13.4932C16.1172 13.8643 15.6777 14.0498 15.1699 14.0498H14.2324V15.6318C14.2324 15.749 14.1738 15.8369 14.0566 15.8955C13.959 15.9541 13.8613 15.9443 13.7637 15.8662L11.3613 14.0498H7.66992C7.16211 14.0498 6.72266 13.8643 6.35156 13.4932C5.98047 13.1221 5.79492 12.6826 5.79492 12.1748V10.2998H10.4824C11.2637 10.2998 11.9277 10.0264 12.4746 9.47949C13.0215 8.93262 13.2949 8.26855 13.2949 7.4873V5.6123H15.1699Z'
                      fill='#FC6441'
                    />
                  </svg>

                  <span>Comment(06)</span>
                </div>
              </div>

              <h3 className='text-lg font-semibold px-5 py-3 font-raleway text-orange-900'>
                The Benefits of hand washing in <br /> controlling Food-borne
                diseases
              </h3>

              <button className='mt-8 bg-orange-500 text-white text-sm px-5 py-2 rounded-md font-raleway flex items-center text-center justify-center w-[180px] h-[44px] hover:bg-orange-600 ml-8'>
                Read More
                <svg
                  width='20'
                  height='21'
                  viewBox='0 0 20 21'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M6.99961 1.19995L5.59961 2.69995L12.9996 10.2L5.59961 17.7L6.99961 19.2L15.9996 10.2L6.99961 1.19995Z'
                    fill='#FDF1E9'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <footer
        className='bg-[#121212] bg-cover bg-center text-white font-raleway'
        style={{ backgroundImage: "url('./Background2.png')" }}
      >
        {/* Top Contact Row */}
        <div className='grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-700'>
          {/* Google Play */}
          <div className='flex items-center justify-center py-6 space-x-3 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='29'
                height='34'
                viewBox='0 0 29 34'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.3529 31.7C15.0809 31.8953 14.7544 32.0004 14.4196 32.0004C14.0847 32.0004 13.7582 31.8953 13.4862 31.7C5.43789 25.9633 -3.10378 14.1633 5.53122 5.63667C7.90179 3.30475 11.0943 1.99854 14.4196 2C17.7529 2 20.9512 3.30833 23.3079 5.635C31.9429 14.1617 23.4012 25.96 15.3529 31.7Z'
                  stroke='white'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
                <path
                  d='M14.4193 16.9997C15.3033 16.9997 16.1512 16.6485 16.7763 16.0234C17.4014 15.3982 17.7526 14.5504 17.7526 13.6663C17.7526 12.7823 17.4014 11.9344 16.7763 11.3093C16.1512 10.6842 15.3033 10.333 14.4193 10.333C13.5352 10.333 12.6874 10.6842 12.0622 11.3093C11.4371 11.9344 11.0859 12.7823 11.0859 13.6663C11.0859 14.5504 11.4371 15.3982 12.0622 16.0234C12.6874 16.6485 13.5352 16.9997 14.4193 16.9997Z'
                  stroke='white'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway'>Location</p>
              <span className='text-white text-sm font-bold '>
                3 Adamu Ciroma Cresent, <br /> Off Ebitu Ukiwe Street, <br />{' '}
                Jabi, Abuja 900108
              </span>
            </div>
          </div>

          {/* Phone Number */}
          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M24.3575 24.5212C24.2381 25.1418 23.8692 25.4576 23.2508 25.4684C17.0018 25.5774 11.6254 23.4574 7.12173 19.1083C2.61805 14.7591 0.311678 9.46001 0.2026 3.21096C0.191806 2.59257 0.494471 2.21288 1.11059 2.07189L6.16749 0.811571C6.78305 0.638041 7.22641 0.858202 7.49758 1.47205L9.93642 6.89907C10.1733 7.41584 10.0674 7.87349 9.61854 8.27201L6.73105 10.7154C7.64334 12.6203 8.86085 14.292 10.3836 15.7305C11.9069 17.2015 13.6201 18.36 15.5231 19.2058L17.9131 16.2339C18.2631 15.772 18.7168 15.6502 19.2741 15.8683L24.7829 18.1163C25.3733 18.3664 25.5925 18.8021 25.4406 19.4234L24.3575 24.5212Z'
                  fill='white'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway pl-3'>
                Phone:
              </p>
              <span className='text-white text-sm font-Sora  px-3'>
                +2347025050009
              </span>
            </div>
          </div>
          {/* Email */}
          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='26'
                height='20'
                viewBox='0 0 26 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M25.4115 6.95117C25.5092 6.85352 25.6068 6.83724 25.7045 6.90234C25.8347 6.96745 25.8998 7.0651 25.8998 7.19531V17.1562C25.8998 17.8073 25.6719 18.3607 25.2162 18.8164C24.7605 19.2721 24.2071 19.5 23.5561 19.5H3.24356C2.59251 19.5 2.03913 19.2721 1.5834 18.8164C1.12767 18.3607 0.899805 17.8073 0.899805 17.1562V7.19531C0.899805 7.0651 0.948633 6.98372 1.04629 6.95117C1.1765 6.88607 1.29043 6.88607 1.38809 6.95117C2.46231 7.76497 4.96882 9.60417 8.90762 12.4688C8.97272 12.5339 9.18431 12.7129 9.54238 13.0059C9.93301 13.2988 10.2423 13.5267 10.4701 13.6895C10.698 13.8197 10.991 13.9987 11.349 14.2266C11.7071 14.4219 12.0489 14.5684 12.3744 14.666C12.7325 14.7637 13.0743 14.8125 13.3998 14.8125C13.6928 14.8125 13.9857 14.7799 14.2787 14.7148C14.5717 14.6172 14.8484 14.5195 15.1088 14.4219C15.3692 14.2917 15.6459 14.1289 15.9389 13.9336C16.2318 13.7383 16.476 13.5755 16.6713 13.4453C16.8666 13.2826 17.0945 13.1035 17.3549 12.9082C17.6153 12.7129 17.7943 12.5664 17.892 12.4688C21.7331 9.70182 24.2396 7.86263 25.4115 6.95117ZM13.3998 13.25C13.1394 13.25 12.8139 13.1686 12.4232 13.0059C12.0652 12.8105 11.7722 12.6478 11.5443 12.5176C11.3165 12.3548 10.9747 12.1107 10.5189 11.7852C10.0958 11.4271 9.8679 11.248 9.83535 11.248C5.864 8.35091 3.03197 6.2513 1.33926 4.94922C1.04629 4.72135 0.899805 4.41211 0.899805 4.02148V3.09375C0.899805 2.44271 1.12767 1.88932 1.5834 1.43359C2.03913 0.977865 2.59251 0.75 3.24356 0.75H23.5561C24.2071 0.75 24.7605 0.977865 25.2162 1.43359C25.6719 1.88932 25.8998 2.44271 25.8998 3.09375V4.02148C25.8998 4.41211 25.7533 4.72135 25.4604 4.94922C23.8653 6.1862 21.0333 8.28581 16.9643 11.248C16.9317 11.248 16.6876 11.4271 16.2318 11.7852C15.8087 12.1107 15.4831 12.3548 15.2553 12.5176C15.0274 12.6478 14.7182 12.8105 14.3275 13.0059C13.9695 13.1686 13.6602 13.25 13.3998 13.25Z'
                  fill='white'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway pl-3'>
                Email:
              </p>
              <span className='text-white text-sm font-raleway font-bold px-3 pr-4'>
                NGA.Enrichdlp@care.org
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Footer Content */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 py-10 px-6 md:px-16'>
          {/* Logo and Social */}
          <div className='flex flex-col items-center text-center space-y-3'>
            <img
              src='/Care-logo.png'
              alt='Care eLearning'
              className='w-[150px] sm:w-[180px] md:w-[198px] h-auto'
            />
            <div className='text-center'>
              <p className='mb-4'>
                Follow us on any social platform to <br /> get latest updates
                and events.
              </p>
            </div>

            <div className='flex items-center space-x-2 '>
              {/* Facebook */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='10'
                  height='18'
                  viewBox='0 0 10 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.61679 9.6875H6.12655V17.125H2.80624V9.6875H0.0835857V6.63281H2.80624V4.27539C2.80624 1.61914 4.39999 0.125 6.82382 0.125C7.98593 0.125 9.21445 0.357422 9.21445 0.357422V2.98047H7.85312C6.52499 2.98047 6.12655 3.77734 6.12655 4.64062V6.63281H9.08163L8.61679 9.6875Z'
                    fill='#E8721F'
                  />
                  <a href='https://web.facebook.com/CAREinNigeria/?_rdc=1&_rdr#' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.162687'
                      y='-1.275'
                      width='10.625'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
              {/* Instagram */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='16'
                  height='20'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M7.68632 3.80664C9.77812 3.80664 11.5047 5.5332 11.5047 7.625C11.5047 9.75 9.77812 11.4434 7.68632 11.4434C5.56132 11.4434 3.86796 9.75 3.86796 7.625C3.86796 5.5332 5.56132 3.80664 7.68632 3.80664ZM7.68632 10.1152C9.04765 10.1152 10.1434 9.01953 10.1434 7.625C10.1434 6.26367 9.04765 5.16797 7.68632 5.16797C6.29179 5.16797 5.19609 6.26367 5.19609 7.625C5.19609 9.01953 6.32499 10.1152 7.68632 10.1152ZM12.534 3.67383C12.534 4.17188 12.1355 4.57031 11.6375 4.57031C11.1394 4.57031 10.741 4.17188 10.741 3.67383C10.741 3.17578 11.1394 2.77734 11.6375 2.77734C12.1355 2.77734 12.534 3.17578 12.534 3.67383ZM15.0574 4.57031C15.1238 5.79883 15.1238 9.48438 15.0574 10.7129C14.991 11.9082 14.7254 12.9375 13.8621 13.834C12.9988 14.6973 11.9363 14.9629 10.741 15.0293C9.51249 15.0957 5.82695 15.0957 4.59843 15.0293C3.40312 14.9629 2.37382 14.6973 1.47734 13.834C0.614055 12.9375 0.34843 11.9082 0.282023 10.7129C0.215617 9.48438 0.215617 5.79883 0.282023 4.57031C0.34843 3.375 0.614055 2.3125 1.47734 1.44922C2.37382 0.585938 3.40312 0.320312 4.59843 0.253906C5.82695 0.1875 9.51249 0.1875 10.741 0.253906C11.9363 0.320312 12.9988 0.585938 13.8621 1.44922C14.7254 2.3125 14.991 3.375 15.0574 4.57031ZM13.4637 12.0078C13.8621 11.0449 13.7625 8.7207 13.7625 7.625C13.7625 6.5625 13.8621 4.23828 13.4637 3.24219C13.198 2.61133 12.7 2.08008 12.0691 1.84766C11.073 1.44922 8.74882 1.54883 7.68632 1.54883C6.59062 1.54883 4.2664 1.44922 3.30351 1.84766C2.63945 2.11328 2.1414 2.61133 1.87577 3.24219C1.47734 4.23828 1.57695 6.5625 1.57695 7.625C1.57695 8.7207 1.47734 11.0449 1.87577 12.0078C2.1414 12.6719 2.63945 13.1699 3.30351 13.4355C4.2664 13.834 6.59062 13.7344 7.68632 13.7344C8.74882 13.7344 11.073 13.834 12.0691 13.4355C12.7 13.1699 13.2312 12.6719 13.4637 12.0078Z'
                    fill='#E8721F'
                  />
                  <a href='https://www.instagram.com/care_ngr?igsh=MTc1amdpazVtNnRneQ' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.18925'
                      y='-1.275'
                      width='14.875'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
              
              {/* Twitter */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='18'
                  height='15'
                  viewBox='0 0 18 15'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15.4402 4.17188C15.4402 4.33789 15.4402 4.4707 15.4402 4.63672C15.4402 9.25195 11.9539 14.5312 5.5457 14.5312C3.55352 14.5312 1.72734 13.9668 0.200001 12.9707C0.465626 13.0039 0.731251 13.0371 1.03008 13.0371C2.65703 13.0371 4.15117 12.4727 5.34649 11.543C3.81914 11.5098 2.52422 10.5137 2.09258 9.11914C2.325 9.15234 2.52422 9.18555 2.75664 9.18555C3.05547 9.18555 3.3875 9.11914 3.65313 9.05273C2.05938 8.7207 0.864063 7.32617 0.864063 5.63281V5.59961C1.32891 5.86523 1.89336 5.99805 2.45781 6.03125C1.49492 5.40039 0.897266 4.33789 0.897266 3.14258C0.897266 2.47852 1.06328 1.88086 1.36211 1.38281C3.08867 3.47461 5.67852 4.86914 8.56719 5.03516C8.50078 4.76953 8.46758 4.50391 8.46758 4.23828C8.46758 2.3125 10.0281 0.751953 11.9539 0.751953C12.95 0.751953 13.8465 1.15039 14.5105 1.84766C15.2742 1.68164 16.0379 1.38281 16.702 0.984375C16.4363 1.81445 15.9051 2.47852 15.1746 2.91016C15.8719 2.84375 16.5691 2.64453 17.1668 2.37891C16.702 3.07617 16.1043 3.67383 15.4402 4.17188Z'
                    fill='#E8721F'
                  />
                  <a href='https://x.com/CARE_Nigeria' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.200001'
                      y='-1.275'
                      width='17'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
            </div>
          </div>

          {/* Subsribe */}
          {/* <div className='flex flex-col  space-y-6'>
            <h3 className='font-raleway font-bold text-2xl'>Subscribe</h3>
            <input
              type='email'
              placeholder='Enter your email:'
              className='w-80 px-4 py-4 mb-3 rounded-sm font-raleway text-black'
            />

            <button className='bg-orange-500 text-white px-4 py-4 mr-[199px] rounded font-raleway hover:bg-orange-600 '>
              SUBSCRIBE NOW
            </button>
          </div> */}
          {/* Links */}
          <div className='flex flex-col items-center teaxt-center space-y-5'>
            <h3 className='text-2xl font-bold font-raleway mr-16'>Links</h3>
            <ul className='space-y-3 font-raleway ml-14'>
              {[
                { label: 'Courses', href: '/courses' },
                { label: 'Privacy Policy', href: '/privacy-policy' },
                { label: 'Terms and Conditions', href: '/terms-and-conditions' },
                { label: 'About Us', href: '/about' },
                { label: 'Blog News', href: '/blog' },
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    className='flex items-center space-x-6 hover:text-orange-500'
                  >
                    {/* SVG icon */}
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='w-4 h-4 text-white'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M9 5l7 7-7 7'
                      />
                    </svg>
                    <span>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Google App*/}
          <div className='flex flex-col  space-y-6'>
            <div className='text-left'>
              <h3 className='font-raleway font-bold text-2xl pr-20'>
                Download
              </h3>
            </div>

            <div className='flex items-center justify-center py-6 space-x-3 '>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                <svg
                  width='41'
                  height='41'
                  viewBox='0 0 41 41'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667M20.5 7.16699H17.1667V17.167H13L20.5 24.667'
                    fill='white'
                  />
                  <path
                    d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667L13 17.167H17.1667V7.16699H20.5Z'
                    stroke='white'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M10.5 32.167H30.5'
                    stroke='white'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              </div>
              <div className='text-left'>
                <img
                  src='./Google Play.png'
                  alt='Thumb 1'
                  className=' h-[62px] w-[290px]'
                />
              </div>
            </div>
          </div>
        </div>
      </footer>

      <footer className='w-full h-[70.3px] bg-black space-y-4 py-16 px-6 md:px-20'>
        <div className='flex justify-center text-center'>
          <div className=' text-white text-center font-raleway text-sm'>
            Copyright © 2026{' '}
            <span className='text-orange-500'>CARE Nigeria</span> || All Rights
            Reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Section8;
